import {IProductDepositPriceInfo, IProductPriceInfo} from '../components/app/income-document-detail/TabDocumentDetail'
import {round} from 'lodash'
import {IncomeDocumentTypes} from '../constants/Common'
import {IIncomeDocument} from '../components/app/IncomeDocumentDetailPage'

export interface IProductAccountSummary {
  productPriceInfo: IProductPriceInfo
  depositPriceInfo: IProductDepositPriceInfo
}

const defaultProductPriceInfo: IProductPriceInfo = {
  total: 0,
  subTotal: 0,
  depositTotal: 0,
  beforeDepositTotal: 0,
  discountTotal: 0,
  whTaxTotal: 0,
  vatTotal: 0,
  vatItemPriceTotal: 0,
  zeroVatItemPriceTotal: 0,
  noVatItemPriceTotal: 0,
}

const defaultProductDepositPriceInfo: IProductDepositPriceInfo = {
  total: 0,
  subTotal: 0,
  depositTotal: 0,
  beforeDepositTotal: 0,
  discountTotal: 0,
  whTaxPrice: 0,
  vatTotal: 0,
  vatItemPriceTotal: 0,
  zeroVatItemPriceTotal: 0,
  noVatItemPriceTotal: 0,
}

export const calculateSummaryPriceInfo = (document: IIncomeDocument) => {
  let sumInfo = defaultProductPriceInfo
  let productPriceInfo = defaultProductPriceInfo
  let depositPriceInfo = defaultProductDepositPriceInfo

  const currentDepositDeductionDocuments = document?.incomeDocumentDepositDeductions
  const relateDepositDeductionDocuments = document?.linkingDocument?.incomeDocumentDepositDeductions
  const isReceiptBilling = document.type === 'receipt' && document.linkingDocument?.billingDocuments?.length

  let previousCorrectPrice = 0
  document.incomeDocumentItems.map((item: any) => {
    const subTotal = item.beforeVatPrice
    const vatTotal = item.vatPrice

    sumInfo = {
      ...sumInfo,
      total: sumInfo.total += subTotal,
      subTotal: sumInfo.subTotal += subTotal - item.whTaxPrice,
      discountTotal: sumInfo.discountTotal += item.discountPerUnit * item.quantity,
      whTaxTotal: sumInfo.whTaxTotal += item.whTaxPrice,
      zeroVatItemPriceTotal: sumInfo.zeroVatItemPriceTotal += item.vat === 0 ? subTotal : 0,
      noVatItemPriceTotal: sumInfo.noVatItemPriceTotal += item.vat === 99 ? subTotal : 0,
      vatTotal: sumInfo.vatTotal += vatTotal,
      vatItemPriceTotal: sumInfo.vatItemPriceTotal += item.vat === 7 ? subTotal : 0,
    }
  })

  const total = sumInfo.vatTotal + sumInfo.vatItemPriceTotal + sumInfo.noVatItemPriceTotal + sumInfo.zeroVatItemPriceTotal

  sumInfo = {
    ...sumInfo,
    total: total,
    subTotal: total - sumInfo.whTaxTotal,
  }

  if (document?.incomeDocumentDepositDeductions?.length) {
    let depositSumInfo: IProductDepositPriceInfo = {
      total: 0,
      subTotal: 0,
      depositTotal: 0,
      beforeDepositTotal: 0,
      discountTotal: 0,
      whTaxPrice: 0,
      vatTotal: 0,
      vatItemPriceTotal: 0,
      zeroVatItemPriceTotal: 0,
      noVatItemPriceTotal: 0,
    }

    document.incomeDocumentDepositDeductions.map((v: any) => {
      const depositDoc = v.deposit
      const creditDocuments = depositDoc.childrenDocuments.filter((item: any) => item.type === 'credit')
      const creditTotalAmount = creditDocuments.reduce((a: any, b: any) => a + b.totalAmount, 0)
      const creditVatTotalAmount = creditDocuments.reduce((a: any, b: any) => a + b.vatPrice, 0)

      depositDoc.incomeDocumentItems.map((vi: any) => {
        const netPricePerUnit = vi.pricePerUnit - vi.discountPerUnit
        const subTotal = netPricePerUnit * vi.quantity
        let vatTotal = vi.vat === 7 ? subTotal * (vi.vat / 100) : 0

        if (depositDoc.vatType === 'included') {
          vatTotal = vi.vat === 7
            ? round(subTotal - (subTotal * 100 / (100 + vi.vat)), 2)
            : 0
        }

        depositSumInfo = {
          ...depositSumInfo,
          zeroVatItemPriceTotal: depositSumInfo.zeroVatItemPriceTotal += vi.vat === 0 ? subTotal : 0,
          noVatItemPriceTotal: depositSumInfo.noVatItemPriceTotal += vi.vat === 99 ? subTotal : 0,
          vatItemPriceTotal: depositSumInfo.vatItemPriceTotal += vi.vat === 7
            ? (depositDoc.vatType === 'included'
                ? subTotal - vatTotal
                : subTotal
            ) : 0,
          vatTotal: depositSumInfo.vatTotal += vatTotal,
        }
      })

      if (creditDocuments.length) {
        creditDocuments?.map((doc: any) => {
          doc?.incomeDocumentItems?.map((item: any) => {
            const netPricePerUnit = item.pricePerUnit - item.discountPerUnit
            const subTotal = netPricePerUnit * item.quantity
            let vatTotal = item.vat === 7 ? subTotal * (item.vat / 100) : 0

            if (depositDoc.vatType === 'included') {
              vatTotal = item.vat === 7
                ? round(subTotal - (subTotal * 100 / (100 + item.vat)), 2)
                : 0
            }

            depositSumInfo = {
              ...depositSumInfo,
              zeroVatItemPriceTotal: depositSumInfo.zeroVatItemPriceTotal -= item.vat === 0 ? subTotal : 0,
              noVatItemPriceTotal: depositSumInfo.noVatItemPriceTotal -= item.vat === 99 ? subTotal : 0,
              vatItemPriceTotal: depositSumInfo.vatItemPriceTotal -= item.vat === 7
                ? (depositDoc.vatType === 'included'
                    ? subTotal - vatTotal
                    : subTotal
                ) : 0,
              vatTotal: depositSumInfo.vatTotal -= vatTotal,
            }
          })
        })
      }

      depositSumInfo = {
        ...depositSumInfo,
        vatTotal: round(depositSumInfo.vatTotal, 2),
        total: depositSumInfo.total += depositDoc.totalAmount - creditTotalAmount,
        whTaxPrice: depositSumInfo.whTaxPrice += depositDoc.whTaxPrice,
      }
    })

    depositPriceInfo = depositSumInfo

    const beforeDepositTotal = document.vatType === 'excluded' ? total - sumInfo.vatTotal : total
    const depositAmountValue = document.vatType === 'excluded'
      ? depositSumInfo.noVatItemPriceTotal + depositSumInfo.zeroVatItemPriceTotal + depositSumInfo.vatItemPriceTotal
      : depositSumInfo.total

    sumInfo = {
      ...sumInfo,
      depositTotal: depositAmountValue,
      beforeDepositTotal: beforeDepositTotal,
      zeroVatItemPriceTotal: sumInfo.zeroVatItemPriceTotal - depositSumInfo.zeroVatItemPriceTotal,
      noVatItemPriceTotal: sumInfo.noVatItemPriceTotal - depositSumInfo.noVatItemPriceTotal,
      vatItemPriceTotal: sumInfo.vatItemPriceTotal - depositSumInfo.vatItemPriceTotal,
      vatTotal: sumInfo.vatTotal - depositSumInfo.vatTotal,
    }

    const dTotal = sumInfo.vatTotal + sumInfo.vatItemPriceTotal + sumInfo.noVatItemPriceTotal + sumInfo.zeroVatItemPriceTotal
    sumInfo = {
      ...sumInfo,
      total: dTotal,
      subTotal: dTotal - sumInfo.whTaxTotal
    }
  }

  if (document.type === 'receipt') {
    let depositDeductionSumInfo: IProductDepositPriceInfo = {
      total: 0,
      subTotal: 0,
      depositTotal: 0,
      beforeDepositTotal: 0,
      discountTotal: 0,
      whTaxPrice: 0,
      vatTotal: 0,
      vatItemPriceTotal: 0,
      zeroVatItemPriceTotal: 0,
      noVatItemPriceTotal: 0,
    }

    relateDepositDeductionDocuments?.map((v: any) => {
      const depositDoc = v.deposit
      const creditDocuments = depositDoc.childrenDocuments.filter((item: any) => item.type === 'credit')
      const creditTotalAmount = creditDocuments.reduce((a: any, b: any) => a + b.totalAmount, 0)
      const creditVatTotalAmount = creditDocuments.reduce((a: any, b: any) => a + b.vatPrice, 0)

      depositDoc.incomeDocumentItems.map((vi: any) => {
        const netPricePerUnit = vi.pricePerUnit - vi.discountPerUnit
        const subTotal = netPricePerUnit * vi.quantity
        let vatTotal = vi.vat === 7 ? subTotal * (vi.vat / 100) : 0

        if (depositDoc.vatType === 'included') {
          vatTotal = vi.vat === 7
            ? round(subTotal - (subTotal * 100 / (100 + vi.vat)), 2)
            : 0
        }

        depositDeductionSumInfo = {
          ...depositDeductionSumInfo,
          zeroVatItemPriceTotal: depositDeductionSumInfo.zeroVatItemPriceTotal += vi.vat === 0 ? subTotal : 0,
          noVatItemPriceTotal: depositDeductionSumInfo.noVatItemPriceTotal += vi.vat === 99 ? subTotal : 0,
          vatItemPriceTotal: depositDeductionSumInfo.vatItemPriceTotal += vi.vat === 7
            ? (depositDoc.vatType === 'included'
                ? subTotal - vatTotal
                : subTotal
            ) : 0,
          vatTotal: depositDeductionSumInfo.vatTotal += vatTotal,
        }
      })

      if (creditDocuments.length) {
        creditDocuments?.map((doc: any) => {
          doc?.incomeDocumentItems?.map((item: any) => {
            const netPricePerUnit = item.pricePerUnit - item.discountPerUnit
            const subTotal = netPricePerUnit * item.quantity
            let vatTotal = item.vat === 7 ? subTotal * (item.vat / 100) : 0

            if (depositDoc.vatType === 'included') {
              vatTotal = item.vat === 7
                ? round(subTotal - (subTotal * 100 / (100 + item.vat)), 2)
                : 0
            }

            depositDeductionSumInfo = {
              ...depositDeductionSumInfo,
              zeroVatItemPriceTotal: depositDeductionSumInfo.zeroVatItemPriceTotal -= item.vat === 0 ? subTotal : 0,
              noVatItemPriceTotal: depositDeductionSumInfo.noVatItemPriceTotal -= item.vat === 99 ? subTotal : 0,
              vatItemPriceTotal: depositDeductionSumInfo.vatItemPriceTotal -= item.vat === 7
                ? (depositDoc.vatType === 'included'
                    ? subTotal - vatTotal
                    : subTotal
                ) : 0,
              vatTotal: depositDeductionSumInfo.vatTotal -= vatTotal,
            }
          })
        })
      }

      depositDeductionSumInfo = {
        ...depositDeductionSumInfo,
        vatTotal: round(depositDeductionSumInfo.vatTotal, 2),
        total: depositDeductionSumInfo.total += depositDoc.totalAmount - creditTotalAmount,
        whTaxPrice: depositDeductionSumInfo.whTaxPrice += depositDoc.whTaxPrice,
      }
    })

    if (relateDepositDeductionDocuments?.length) {
      const beforeDepositTotal = document.vatType === 'excluded' ? total - sumInfo.vatTotal : total
      const depositAmountValue = document.vatType === 'excluded'
        ? depositDeductionSumInfo.noVatItemPriceTotal + depositDeductionSumInfo.zeroVatItemPriceTotal + depositDeductionSumInfo.vatItemPriceTotal
        : depositDeductionSumInfo.total

      sumInfo = {
        ...sumInfo,
        depositTotal: depositAmountValue,
        beforeDepositTotal: beforeDepositTotal,
      }

      depositPriceInfo = depositDeductionSumInfo
    }

    sumInfo = {
      ...sumInfo,
      zeroVatItemPriceTotal: sumInfo.zeroVatItemPriceTotal - depositDeductionSumInfo.zeroVatItemPriceTotal,
      noVatItemPriceTotal: sumInfo.noVatItemPriceTotal - depositDeductionSumInfo.noVatItemPriceTotal,
      vatItemPriceTotal: sumInfo.vatItemPriceTotal - depositDeductionSumInfo.vatItemPriceTotal,
      vatTotal: sumInfo.vatTotal - depositDeductionSumInfo.vatTotal,
      total: sumInfo.total - depositDeductionSumInfo.total,
      subTotal: sumInfo.subTotal - depositDeductionSumInfo.total + depositDeductionSumInfo.whTaxPrice,
      whTaxTotal: sumInfo.whTaxTotal - depositDeductionSumInfo.whTaxPrice
    }
  }

  if (document.type === 'billing' || isReceiptBilling) {
    let billingDocuments = document.billingDocuments
    if (isReceiptBilling) {
      billingDocuments = document.linkingDocument?.billingDocuments
    }

    billingDocuments.map((item) => {
      const currentDocument = item.originalDocument
      const amount = Number(item.billingAmount);
      const total = currentDocument.totalAmount;
      const totalWhTax = currentDocument?.whTaxPrice || 0;

      const proportion = amount / total;
      const percentage = proportion * 100;
      const roundedPercentage = Math.round(percentage * 100) / 100;
      const whTax = Number((totalWhTax * (roundedPercentage / 100)).toFixed(2));
      const isMinusType = currentDocument.type === IncomeDocumentTypes.CREDIT
      const totalBeforeVat = currentDocument.incomeDocumentItems.reduce((a: any, b: any) => {
        return a + ((b.pricePerUnit - b.discountPerUnit) * b.quantity)
      }, 0)

      if (isMinusType) {
        sumInfo = {
          ...sumInfo,
          total: sumInfo.total - Number(item.billingAmount),
          whTaxTotal: sumInfo.whTaxTotal - whTax,
        }
      } else {
        sumInfo = {
          ...sumInfo,
          total: sumInfo.total + Number(item.billingAmount),
          whTaxTotal: sumInfo.whTaxTotal + whTax,
        }
      }

      currentDocument.incomeDocumentItems.map((item: any) => {
        const netPricePerUnit = item.pricePerUnit - item.discountPerUnit
        const subTotal = parseFloat((amount * ((netPricePerUnit * item.quantity) / totalBeforeVat)).toFixed(2))
        const vatTotal = item.vat === 7
          ? Math.floor((subTotal - (subTotal * 100) / (100 + item.vat)) * 100) / 100
          : 0

        if (isMinusType) {
          sumInfo = {
            ...sumInfo,
            discountTotal: sumInfo.discountTotal -= item.discountPerUnit * item.quantity,
            zeroVatItemPriceTotal: sumInfo.zeroVatItemPriceTotal -= item.vat === 0 ? subTotal : 0,
            noVatItemPriceTotal: sumInfo.noVatItemPriceTotal -= item.vat === 99 ? subTotal : 0,
            vatTotal: sumInfo.vatTotal -= vatTotal,
            vatItemPriceTotal: sumInfo.vatItemPriceTotal -= item.vat === 7 ? subTotal - vatTotal : 0,
          }
        } else {
          sumInfo = {
            ...sumInfo,
            discountTotal: sumInfo.discountTotal += item.discountPerUnit * item.quantity,
            zeroVatItemPriceTotal: sumInfo.zeroVatItemPriceTotal += item.vat === 0 ? subTotal : 0,
            noVatItemPriceTotal: sumInfo.noVatItemPriceTotal += item.vat === 99 ? subTotal : 0,
            vatTotal: sumInfo.vatTotal += vatTotal,
            vatItemPriceTotal: sumInfo.vatItemPriceTotal += item.vat === 7 ? subTotal - vatTotal : 0,
          }
        }
      })
    })

    sumInfo = {
      ...sumInfo,
      subTotal: sumInfo.total - sumInfo.whTaxTotal,
    }
  }

  if (['debit', 'credit'].includes(document.type)) {
    document.linkingDocument?.incomeDocumentItems?.map((item: any) => {
      const netPrice = (item.pricePerUnit - item.discountPerUnit) * item.quantity

      if (document.vatType === 'included') {
        previousCorrectPrice += netPrice - item.vatPrice
      } else {
        previousCorrectPrice += netPrice
      }
    })

    sumInfo = {
      ...sumInfo,
      total: total - Number(productPriceInfo?.depositTotal),
      subTotal: total - sumInfo.whTaxTotal - Number(productPriceInfo?.depositTotal),
      depositTotal: productPriceInfo.depositTotal,
    }

    if (document.type === 'debit') {
      sumInfo = {
        ...sumInfo,
        correctPrice: previousCorrectPrice + sumInfo.vatItemPriceTotal + sumInfo.noVatItemPriceTotal + sumInfo.zeroVatItemPriceTotal,
        beforeCorrectPrice: previousCorrectPrice
      }
    }

    if (document.type === 'credit') {
      sumInfo = {
        ...sumInfo,
        correctPrice: previousCorrectPrice - sumInfo.vatItemPriceTotal - sumInfo.noVatItemPriceTotal - sumInfo.zeroVatItemPriceTotal,
        beforeCorrectPrice: previousCorrectPrice
      }
    }
  }

  productPriceInfo = sumInfo

  return {
    productPriceInfo,
    depositPriceInfo,
  }
}
